import { getCookie, setCookie } from "typescript-cookie";
import { create } from "zustand";
import { CurrentActiveUserInterface } from "../constants/User";
import { useUserHeader } from "./useUserHeader";

interface UserLoginInterface {
  loggedUsers: CurrentActiveUserInterface[] | string;
  currentActiveUser: CurrentActiveUserInterface | null;
  getCurrentActiveUser: () => void;
  getReturnActiveUser: () => Promise<CurrentActiveUserInterface | null>;
  saveCurrentActiveUser: (userData: CurrentActiveUserInterface) => void;
  getLoggedUsers: () => void;
  saveLoggedUsers: (userData: any) => void;
}

export const useGetUserLoginStore = create<UserLoginInterface>((set) => ({
  loggedUsers: [],
  currentActiveUser: null,

  getCurrentActiveUser: () => {
    const getCurrentUserCookies = getCookie("currentActiveUser") || null;
    const currentActiveUser: CurrentActiveUserInterface = getCurrentUserCookies
      ? JSON.parse(getCurrentUserCookies)
      : null;
    set({ currentActiveUser: currentActiveUser });
  },

  getReturnActiveUser: async () => {
    try {
      // Ambil cookie (sinkron atau asinkron tergantung implementasi `getCookie`)
      const getCurrentUserCookies =
        (await getCookie("currentActiveUser")) || null;

      // Parsing JSON, tangani error jika cookie tidak valid
      let currentActiveUser: CurrentActiveUserInterface | null = null;
      if (getCurrentUserCookies) {
        try {
          currentActiveUser = JSON.parse(getCurrentUserCookies);
        } catch (parseError) {
          console.error("Error parsing currentActiveUser JSON:", parseError);
          currentActiveUser = null;
        }
      }

      // Simpan ke Zustand jika ada user
      if (currentActiveUser) {
        set({ currentActiveUser: currentActiveUser });
      }

      // Kembalikan nilai
      return currentActiveUser;
    } catch (error) {
      console.error("Error fetching currentActiveUser from cookie:", error);
      return null;
    }
  },

  saveCurrentActiveUser: (userData: CurrentActiveUserInterface) => {
    setCookie("currentActiveUser", JSON.stringify(userData), {
      expires: 1,
      path: "/",
    });
    const fetchUserHeader = useUserHeader.getState().fetchUserHeader;
    if (userData.id && userData.role) {
      fetchUserHeader(userData.id, userData.role);
    }
  },

  getLoggedUsers: () => {
    const userCookies = getCookie("loggedUsers") || "[]";
    const loggedUsers = JSON.parse(userCookies);

    set({ loggedUsers: loggedUsers });
  },

  saveLoggedUsers: (loggedUsers) => {
    setCookie("loggedUsers", JSON.stringify(loggedUsers), {
      expires: 1,
      path: "/",
    });
  },
}));
